import { synUtil } from "../../../../javascript/Utilities";
import { AjaxSolr } from "../../core/Core.js";
import { escapeForSolr, unescapeForSolr, stringToDateSolr, dateToStringShort, dateToStringSolr } from "../../core/synerisSolrBase.js";
import "../../core/AbstractFacetWidget.js";
import "flot";

(function ($) {
    AjaxSolr.DateRangeWidget = AjaxSolr.AbstractFacetWidget.extend({
        constructor: function (attributes) {
            AjaxSolr.DateRangeWidget.__super__.constructor.apply(this, arguments);
            AjaxSolr.extend(this, {
                options: undefined
            }, attributes);
        },
        clear: function () {
            return this.changeSelection(function () {
                return this.manager.store.removeByValue('fq', new RegExp('^(\{!tag=[A-Za-z0-9_]+})*-?' + this.field + ':'));
            });
        },
        clearUI: function () {
            let $target = $(this.target);
            let outer = $target.children(".drOuter");
            $target.addClass("baseWidget");
            $target.addClass("dateRangeWidget");
            if (outer.length) {
                // Already exists, destroy and remove all
                let slider = outer.children(".rangeslider").data("kendoRangeSlider");
                if (slider)
                    slider.destroy();
                outer.remove();
            }
        },
        beforeRequest: function () {
            this.clearUI();
            $(this.target).append($("<img style='display:block;margin:auto' src='assets/images/loading_image.gif' class='synAjaxLoad_animation' />"));
        },
        afterRequest: function () {
            let self = this;
            let tgt = $(this.target);
            tgt.trigger("afterRequest");
            let numFound = 0;
            if (this.manager.response.response && this.manager.response.response.numFound)
                numFound = this.manager.response.response.numFound;
            if (numFound) {

                // Create DOM tree
                let outer = $("<div class='drOuter'></div>").appendTo(tgt);
                let chart = $("<div class='chart'></div>").appendTo(outer);
                let slider = $("<div class='rangeslider'></div>").appendTo(outer);
                slider.append($("<input />"));
                slider.append($("<input />"));

                let labelDiv = $("<div class='sliderLabels'></div>").appendTo(outer);

                // TODO GAP
                //At the moment the slider has a step size of 31 days
                let step = new Date(1970, 1, 31).getTime() - new Date(1970, 1, 1).getTime();



                // Get facet info itself
                let facet = this.manager.response.facet_counts.facet_ranges[this.field];
                let min = stringToDateSolr(facet.start);
                let max = stringToDateSolr(facet.end);


                // show min and max dates as labels
                labelDiv.append("<div class='left'>" + dateToStringShort(min) + "</div>");
                labelDiv.append("<div class='right'>" + dateToStringShort(max) + "</div>");

                //TODO: GAP
                let maxCount = 0;
                let values = [];
                for (let key in facet.counts) {
                    if (facet.counts.hasOwnProperty(key)) {
                        let count = facet.counts[key];
                        maxCount = Math.max(maxCount, count);
                        values.push([stringToDateSolr(key).getTime(), count]);
                    }
                }

                let leftSel = min;
                let rightSel = max;

                // Get current date ranges if defined
                let fq = this.manager.store.get("fq");
                if (fq) {
                    $.each(fq, function (index, f) {
                        if (f.value) {
                            let valueWithoutTagParams = f.value.replace(/^\{!tag=[A-Za-z0-9_]+}/, "");
                            let spl = valueWithoutTagParams.split(":[");
                            if (spl.length === 2) {
                                if (spl[0] === self.field) {
                                    let val = spl[1].replace(/]/, "");
                                    let range = val.split(" TO ");
                                    if (range.length === 2) {
                                        if (range[0] !== "*") {
                                            leftSel = stringToDateSolr(range[0]);
                                        }
                                        if (range[1] !== "*") {
                                            rightSel = stringToDateSolr(range[1]);
                                        }
                                    }
                                }
                            }
                        }

                    });
                }

                // Initialize slider
                let rangeFrom = synUtil.Strings.getValue("rangefrom");
                let rangeTo = synUtil.Strings.getValue("rangeto");

                slider.kendoRangeSlider({
                    min: min.getTime(),
                    max: max.getTime(),
                    tickPlacement: "none",
                    selectionStart: leftSel.getTime(),
                    selectionEnd: rightSel.getTime(),
                    smallStep: step,
                    largeStep: step,
                    change: function (e) {
                        let sliderData = slider.data("kendoRangeSlider");
                        if (sliderData) {
                            let dtSlider = new Date(e.value[0]);

                            let leftAll = false, rightAll = false;
                            let left = kendo.toString(new Date(e.value[0]), "yyyy-MM-01'T'HH:mm:ss.fff'Z'");
                            if (e.value[0] === sliderData.options.min) {
                                left = "*";
                                leftAll = true;
                            }

                            let dtTmp = new Date(e.value[1]);
                            let dtCeil = new Date(dtTmp.getFullYear(), dtTmp.getMonth() + 1, 0);
                            let right = dateToStringSolr(dtCeil);
                            if (e.value[1] === sliderData.options.max) {
                                right = "*";
                                rightAll = true;
                            }
                            let val = "[" + left + " TO " + right + "]";

                            //self.manager.store.removeByValue('fq', new RegExp('^-?' + self.field + ':'));
                            self.manager.store.removeByValue('fq', new RegExp('^(\{!tag=[A-Za-z0-9_]+})*-?' + self.field + ':'));
                            if (!leftAll || !rightAll) {
                                self.manager.store.addByValue('fq', "{!tag=" + self.field.replace(/[\._]/, "") + "}" + self.fq(val));
                            }
                            $(".k-slider-tooltip").css("display", "none");
                            self.doRequest();
                        }
                    },
                    tooltip: {
                        template: "# let f=function(t) {let d = new Date(t);return kendo.toString(d, 'MMMM yyyy');};return '<strong>" + rangeFrom + ":</strong> '+f(selectionStart)+'<br/><strong>" + rangeTo + ":</strong> '+f(selectionEnd); #"
                    }
                });

                // Remove slider "drag" tooltip (AA8343)
                $(".k-draghandle").attr("title", "");

                let color = "#245C86";
                if (this.manager.baseColor)
                    color = this.manager.baseColor;
                
                    window.setTimeout(() => {
                    chart.plot([
                        {
                            data: values,
                            color: color
                        }],
                        {
                            grid: {
                                borderWidth: 0,
                                margin: 0,
                                minBorderMargin: 0
                            },
                            lines: {
                                show: true,
                                fill: true,
                                fillColor: color,
                                steps: true,
                                lineWidth: 0,
                                shadowSize: 0
                            },
                            xaxis: {
                                show: false
                            },
                            yaxis: {
                                show: true,
                                labelWidth: 50,
                                font: {
                                    size: 12,
                                },
                            }
                        });
                }, 1);
            }
            if (!numFound)
                tgt.parent().css("display", "none");
            else
                tgt.parent().css("display", "");

            tgt.trigger("facetsReturned", [numFound]);
        },
        cleanUp: function () {
            let tgt = $(this.target);
            // Remove AJAX animations from facet widgets
            tgt.children(".synAjaxLoad_animation").remove();
        }
    });

})(jQuery);
